import { inject, Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';

import { ContextService } from '@ecm/portfolio';
import { RouterService } from '@ecm/router';

@Injectable({
    providedIn: 'root',
})
export class HomeGuard {
    private readonly contextService = inject(ContextService);
    private readonly routerService = inject(RouterService);

    public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.contextService.isAuthenticated().pipe(
            map((isAuthenticated: boolean) => {
                if (!isAuthenticated) {
                    this.routerService.navigate(['page-accueil']);
                }
                return isAuthenticated;
            }),
        );
    }
}
